var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-10 w-full flex flex-row items-center relative"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }